import { FC } from 'react';

import './style.scss';

export const DiscoverSkeletonInfo: FC = () => {
  return (
    <div className="svg-skeleton discover-skeleton-info">
      <svg width="343" height="81" viewBox="0 0 343 81" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.5" width="160" height="28" rx="4" fill="#E6E6E6" />
        <rect y="38.5" width="343" height="16" rx="4" fill="#E6E6E6" />
        <rect y="64.5" width="343" height="16" rx="4" fill="#E6E6E6" />
      </svg>
    </div>
  );
};

export const DiscoverSkeletonTitle: FC = () => {
  return (
    <div className="svg-skeleton discover-skeleton-title">
      <svg width="80" height="25" viewBox="0 0 80 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.5" width="80" height="24" rx="4" fill="#E6E6E6" />
      </svg>
    </div>
  );
};
